// @flow
import React from 'react'
import I18n from 'i18n-react'

type TextRangeFilterProps = {
  checked: boolean,
  onChange: (name: string, checked: boolean) => void,
  parentName?: string,
  textMode: boolean,
  domain: { name: string, start: number, end: number },
}

const TextRangeFilter = (props: TextRangeFilterProps) => {

  const handleOnChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    props.onChange(props.domain.name, event.target.checked)
  }

  const renderValue = () => !props.domain.end ?
    I18n.translate('filter.values.andMore', { value: props.domain.start }) : `${props.domain.start} - ${props.domain.end}`

  if (props.textMode) {
    return props.checked &&
      <li className='d-block d-sm-inline-block'>
        <strong>{renderValue()}</strong>
      </li>
  }

  const id = `filter-${props.parentName || ''}-${props.domain.name}`

  return (
    <div className='py-2'>
      <div className="custom-control custom-checkbox ">
        <input
          checked={props.checked}
          className='custom-control-input'
          data-hj-whitelist
          id={id}
          onChange={handleOnChange}
          type='checkbox'
        />
        <label
          className='custom-control-label'
          htmlFor={id}
        >
          {renderValue()}
        </label>
      </div>
    </div>
  )
}

export default TextRangeFilter
